import React from 'react';
import { Box, Tooltip, CircularProgress } from '@mui/material';
import {
  Done as DoneIcon,
  DoneAll as DoneAllIcon,
  Schedule as ScheduleIcon,
  Error as ErrorIcon
} from '@mui/icons-material';

/**
 * MessageStatusIndicator Component
 * Shows delivery status for sent messages
 */
const MessageStatusIndicator = ({ deliveryStatus, isQueued, queueStatus }) => {
  const getStatusIcon = () => {
    // Handle queued messages
    if (isQueued && queueStatus === 'pending') {
      return (
        <Tooltip title="Message queued for delivery">
          <ScheduleIcon sx={{ fontSize: 16, color: 'inherit', opacity: 0.7 }} />
        </Tooltip>
      );
    }

    if (isQueued && queueStatus === 'processing') {
      return (
        <Tooltip title="Delivering message...">
          <CircularProgress size={12} sx={{ color: 'inherit' }} />
        </Tooltip>
      );
    }

    if (isQueued && queueStatus === 'failed') {
      return (
        <Tooltip title="Message delivery failed">
          <ErrorIcon sx={{ fontSize: 16, color: 'error.main' }} />
        </Tooltip>
      );
    }

    // Handle normal delivery status
    switch (deliveryStatus) {
      case 'read':
        return (
          <Tooltip title="Read">
            <DoneAllIcon sx={{ fontSize: 16, color: 'inherit' }} />
          </Tooltip>
        );
      case 'delivered':
        return (
          <Tooltip title="Delivered">
            <DoneAllIcon sx={{ fontSize: 16, color: 'inherit', opacity: 0.7 }} />
          </Tooltip>
        );
      case 'sent':
      default:
        return (
          <Tooltip title="Sent">
            <DoneIcon sx={{ fontSize: 16, color: 'inherit', opacity: 0.7 }} />
          </Tooltip>
        );
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center'
      }}
    >
      {getStatusIcon()}
    </Box>
  );
};

export default MessageStatusIndicator;
